import React, { useState, useEffect } from 'react';
import Txt from './textInput.js';
import HtmlToReact from 'html-to-react';
let htmlToReactParser = new HtmlToReact.Parser(React);

export default function TextAreaWithCharacterLimit(props) {
  const [highlightForText, setHighlightForText] = useState({ notHighlight: props.message, highlight: '' });
  const [characterLeftForText, setCharacterLeftForText] = useState(
    props.characterLimit - props.message.toString().length
  );

  const changeAdditionalTextMessage = (value) => {
    props.onChange(value);
    // Check with the character limit and show if it exceeds the limit
    getHightLightTextIfExceed(value);
  };

  const getHightLightTextIfExceed = (text) => {
    // Convert new line break
    text = text.replace(/\n$/g, '\n\n');
    let textLength = text.toString().length;
    if (textLength <= props.characterLimit) {
      setHighlightForText({ notHighlight: text, highlight: '' });
    } else {
      let notExceedString = text.toString().substr(0, props.characterLimit);
      let exceedingString = text.toString().substr(props.characterLimit, textLength);
      //let htmlForIt = notExceedString + '<mark>' + exceedingString + '</mark>';
      setHighlightForText({ notHighlight: notExceedString, highlight: exceedingString });
    }
  };

  // To handel the textarea backdrop scroll position if textarea is scrolling
  const textareaBackOnScroll = (event) => {
    let scrollTop = event.target.scrollTop;
    let backdrop = document.getElementById(props.backdropId);
    if (backdrop) {
      backdrop.scrollTop = scrollTop;
    }
  };

  useEffect(() => {
    if (props.message) {
      setCharacterLeftForText(props.characterLimit - props.message.toString().length);
      // Highlight the text if it exceeds
      getHightLightTextIfExceed(props.message);
    } else {
      setCharacterLeftForText(props.characterLimit);
    }
  }, [props.message]);

  return (
    <React.Fragment>
      <div className="textarea-container">
        <div className="backdrop" id={props.backdropId}>
          <div className="highlights">
            {highlightForText.notHighlight}
            <mark>{highlightForText.highlight}</mark>
          </div>
        </div>
        <Txt
          textArea
          rows="3"
          classes="textarea"
          tabIndex={props.tabIndex}
          value={props.message}
          onChange={changeAdditionalTextMessage}
          noTitle
          fieldClasses="ui htxl input textarea mrtnull"
          titlePlaceholder=" "
          onScroll={textareaBackOnScroll}
        />
      </div>
      <div
        className={
          'wa-charsRight text-size-mms pdtnull mrtnull mrbs ' +
          (characterLeftForText < 0 ? 'negative-char-limit-color' : 'positive-char-limit-color')
        }
      >
        <span>{APP.LANGUAGE.NotifyCaller.CharactersRemaining + characterLeftForText}</span>
      </div>
      {props.errorMsg && props.errorMsg != '' ? (
        <div className="error-label no-top">
          <span className="error-pointy-corner" />
          <span className="error-color">{props.errorMsg}</span>
        </div>
      ) : (
        ''
      )}
      <div className="clearfix" />
    </React.Fragment>
  );
}
